import { useSwitcherClientCore } from "hooks/useSwitcherClient";
import styles from "./index.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { LoadingOverlay } from "components/loading-overlay";
import { usePageHeader } from "hooks/usePageHeader";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BroadcastResponseDetails } from "components/entity-details/BroadcastResponseDetails";
export const PracticePage = () => {
    const { t } = useTranslation();

    // Redux state
    const {
        userInfo: {
            MetaData: {
                Details: { ProjectId }
            }
        }
    } = useSelector((state: RootState) => state.user);

    usePageHeader({
        showBreadcrumbs: false,
        subTitle: (
            <Trans
                i18nKey={t("practice-page:sub-title")}
                components={{
                    link1: (
                        <Link
                            to={
                                "https://itunes.apple.com/us/app/switcher-studio-pro/id908386221"
                            }
                            target="_blank"
                            className={styles["link"]}
                        />
                    )
                }}
            />
        )
    });

    // Fetch data
    const { data: broadcasts, loading } = useSwitcherClientCore(
        (client) => client.broadcasts_GetPagedBroadcastsByFilter,
        {
            args: [
                ProjectId,
                1,
                0,
                "Project",
                "Practice",
                "",
                [],
                "All",
                "Date",
                "Desc"
            ],
            requestImmediately: true
        }
    );

    return (
        <LoadingOverlay isLoading={loading}>
            <div className={styles["practice-page"]}>
                <div className={`${styles["playlist-container"]}`}>
                    {!!broadcasts?.TotalRecords ? (
                        broadcasts?.Data?.[0]?.Broadcasts.map(
                            (broadcastResponse) => (
                                <div
                                    key={broadcastResponse?.Details?.Id}
                                    className={`${styles["broadcast-item"]}`}
                                >
                                    <BroadcastResponseDetails
                                        broadcast={broadcastResponse}
                                        badges={false}
                                        showPricing={false}
                                        showEdit={false}
                                        showDownload={false}
                                        allowVideoPlaybackOnThumbnailClick
                                        location="practice"
                                    />
                                </div>
                            )
                        )
                    ) : (
                        <>
                            <div>{t("practice-page:empty-state")}</div>
                        </>
                    )}
                </div>
            </div>
        </LoadingOverlay>
    );
};
